import { CenposAccount } from '../admin/store';

export class CenposAccountViewModel {
    public tenantId: number = 0;
    public enterpriseId: number = 0;
    public storeId: number = 0;
}

export class CenposAccountListViewModel extends CenposAccountViewModel {
    public accounts: CenposAccount[] = [];
}

export class CenposAccountAddOrUpdateViewModel extends CenposAccountViewModel {
    public account: CenposAccount = {};
    public merchantId: string = '';
    public id: string = '';
}
